export var hasValidationErrors = function (validationErrors) {
    if (validationErrors == null) {
        return false;
    }
    else if (Array.isArray(validationErrors)) {
        return validationErrors.length !== 0;
    }
    else {
        return true;
    }
};
export function getFirstValidationError(validationErrors) {
    if (validationErrors == null) {
        return null;
    }
    else if (Array.isArray(validationErrors)) {
        if (validationErrors.length) {
            return validationErrors[0];
        }
        else {
            return null;
        }
    }
    else {
        return validationErrors;
    }
}
;
//# sourceMappingURL=validationUtil.js.map